import { store } from '@/decorators/store';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';
import { IAlertTypeInfo } from '~/api/IAlertTypeInfo';

@store({ id: 'AlertTypesStore' })
export class AlertTypesStore extends AbstractEntityStore<IAlertTypeInfo> {
  protected entityIdKey = 'alertTypeId';
  protected entityValueKey = 'alertTypeName';
}
